export const GET_SENT_CONTENT_REQUEST = 'GET_SENT_CONTENT_REQUEST'

export const GET_RECEIVED_CONTENT_REQUEST = 'GET_RECEIVED_CONTENT_REQUEST'

export const GET_CONTENT_REQUEST = 'GET_CONTENT_REQUEST'

export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'

export const SET_DATE_FILTER = 'SET_DATE_FILTER'

export const TOGGLE_STATUS = 'TOGGLE_STATUS'

export const TOGGLE_CONTENT_TYPE = 'TOGGLE_CONTENT_TYPE'

export const TOGGLE_PRIORITY = 'TOGGLE_PRIORITY'

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT' // Note: Set search by ID or title in reducer

export const DELETE_CONTENT_REQUEST = 'DELETE_CONTENT_REQUEST'

export const EDIT_CONTENT_REQUEST = 'EDIT_CONTENT_REQUEST'


export const NEXT_PAGE = 'NEXT_PAGE'

export const PREVIOUS_PAGE = 'PREVIOUS_PAGE'

export const FIRST_PAGE = 'FIRST_PAGE'

export const GET_OWNER_TASK_BY_ROLE = 'GET_OWNER_TASK_BY_ROLE'

export const LAST_PAGE = 'LAST_PAGE'

export const FETCH_SUBJECTS='FETCH_SUBJECTS'

export const ADD_SUBJECT='ADD_SUBJECT'

export const GET_FEEDBACK='GET_FEEDBACK'

export const FETCH_OWNERS='FETCH_OWNERS'

export const ADD_NEW_FEEDBACK= 'ADD_NEW_FEEDBACK'

export const RESOLVE_FEEDBACK = 'RESOLVE_FEEDBACK'

export const REPLY_FEEDBACK = 'REPLY_FEEDBACK'

export const UPDATE_CURRENT_PAGE = 'UPDATE_CURRENT_PAGE'

export const ADD_AUTHOR_ROLE = 'ADD_AUTHOR_ROLE'
